module.exports = __webpack_public_path__ + "static/media/sf_1200.a24ee60f0d94426e942cbc630941613d.png";